export default {
  slug: 'getting-started',
  title: 'Getting started',
  description: 'First login, navigation, and your first investigation workflow.',
  section: 'start',
  order: 1,
  tags: ['onboarding', 'navigation', 'workflow'],
  body: `# Getting started

Welcome to **Hivemind Subterfuge Platform** — the unified workspace for intelligence enrichment, case management, and controlled engagement.

## Sign in

Use your operator credentials at the login screen. If MFA is enabled on your account, complete the TOTP step before entering the platform.

## Navigate the platform

The sidebar is organized into four areas:

| Section | Purpose |
|---------|---------|
| **Intelligence** | Search, enrich, extract, and compare indicators |
| **Investigations** | Cases, indicators, evidence, reports, audit |
| **Engagement** | Personas, decoy assets, intake endpoints, workflows |
| **System** | Settings, documentation |

Press **⌘K** (Mac) or **Ctrl+K** (Windows/Linux) anywhere to open the **command palette** and jump to any page instantly.

## Recommended first workflow

1. Open **[Intelligence → Search](/intelligence/search)** and run enrichment on a known indicator (IP, domain, email, wallet, etc.).
2. Review the result page — enrichment sections, relationships, and risk score.
3. **Promote** the search to an **indicator** and optionally attach it to a **[case](/cases)**.
4. Open the **investigation graph** from the case or indicator to pivot across linked entities.
5. Upload supporting artifacts to the **[Evidence vault](/evidence)** and link them to the case.

## Entity-first navigation

Most records open in a consistent **entity detail shell** with tabs for overview, relationships, enrichment, and raw JSON. Look for typed badges and pivot links — click any linked case, indicator, or search to move through the investigation without losing context.

## Need help?

- Browse this wiki from the sidebar under **System → Documentation**
- Use the in-wiki search to find workflows, glossary terms, and shortcuts
- See **[Keyboard shortcuts](/docs/keyboard-shortcuts)** for power-user navigation
`,
};
